import React from 'react'

const ImagesContext = React.createContext({})
export const ImagesProvider = ImagesContext.Provider
export default ImagesContext
